import { __rest } from 'tslib';
import React from 'react';
import { FormControlLabel } from '@mui/material';
import { PeekCheckbox } from './PeekCheckbox.js';

const PeekInputCheckbox = (_a) => {
    var { label, field, form, required } = _a, props = __rest(_a, ["label", "field", "form", "required"]);
    return React.createElement(FormControlLabel, { control: React.createElement(PeekCheckbox, Object.assign({ color: "success" }, props, field)), label: label });
};

export { PeekInputCheckbox, PeekInputCheckbox as default };
